// extracted by mini-css-extract-plugin
module.exports = {"product":"ProductPage_product__3tGLM","status":"ProductPage_status__1MSuv"};